/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs */

const es_components_upgrade_plan_modal_plans_enterprise_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const en_components_upgrade_plan_modal_plans_enterprise_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_enterprise_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Enterprise_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_enterprise_title(inputs)
	return en_components_upgrade_plan_modal_plans_enterprise_title(inputs)
});
export { components_upgrade_plan_modal_plans_enterprise_title as "components.upgrade_plan_modal.plans.enterprise.title" }